/**
 * 定数置き場
 */

/**
 * 機能タイプ
 */
export const FUNCTION_TYPE = {
  COMMON: '0',
  GPS: '1',
  STATUS: '2',
  SEND_MESSAGE: '3',
  CHECKIN: '4',
  REPORT: '5',
  PUSH: '6',
  AREA: '7',
  PLACE: '8',
  USER: '9',
  INFORMATION: '10',
  SCHEDULE: '11',
  TIMELINE: '12',
  MAP: '13',
  ANALYZE: '14',
  INDOOR: '100',
  LOCATION_INDOOR_HIGH: '101',
  FIXED_GATEWAY: '110',
  SENSOR: '200',
}

/**
 * アクティビティコード
 */
export const ACTIVITY_CODE = {
  STILL: '0',
  WALK: '1',
  RUNNING: '2',
  BICYCLE: '3',
  VEHICLE: '4',
}

/**
 * 測位ステータスコード
 */
export const POSITIONING_STATUS_CODE = {
  GPS: '1',
  WIFI: '2',
  OPTIMAL: '3',
  TRACKER: '4',
  INDOOR: '10',
}

/**
 * 測位精度評価コード
 */
export const ACCURACY_RATING_CODE = {
  HIGH: 'H',
  MIDDLE: 'M',
  LOW: 'L',
  OUT_OF_SCOPE: '-',
}

/**
 * API
 */
export const NULL_STRING_API = '\x00'

/**
 * マップレイヤー参照テーブル種類
 * 屋内レイヤーは実質的にIDとして扱われる
 */
export const MAP_LAYER_REFERENCE_TABLE_TYPE = {
  PLACE: +FUNCTION_TYPE.PLACE,
  INDOOR_SITE: 1001,
  INDOOR_BUILDING: 1002,
}

/**
 * 日時関連
 */
// 最小時刻
export const MINIMUM_TIME = '00:00:00'
// 最大時刻
export const MAXIMUM_TIME = '23:59:59'
// 日付フォーマット(ハイフン)
export const DATE_FORMAT_HYPHEN = 'YYYY-MM-DD'
// 日付フォーマット(スラッシュ)
export const DATE_FORMAT_SLASH = 'YYYY/MM/DD'
// 時刻フォーマット(分まで)
export const TIME_FORMAT_MINUTE = 'HH:mm'
// 時刻フォーマット(秒まで)
export const TIME_FORMAT_SECOND = 'HH:mm:ss'
// 時刻フォーマット(ミリ秒まで)
export const TIME_FORMAT_MILLISECOND = 'HH:mm:ss.SSS'
// API用日時フォーマット
export const DATETIME_FORMAT_API = 'YYYY-MM-DDTHH:mm:ss'
// サーバーのタイムゾーン
export const SERVER_TIMEZONE = 'Asia/Tokyo'

/**
 * インターバル
 */
// インターバルに設定出来る最大値
export const MAX_SAFE_INTERVAL_DELAY = Math.pow(2, 31) - 1

/**
 * 関数
 */
// 何もしない関数
export const NO_OP = () => {}

/**
 * ストレージ
 */
// localStorageに保存するキーに付与するprefix
export const LOCAL_STORAGE_KEY_PREFIX = 'iField4_usersWeb'
// localStorageにレイヤー表示状態を保存するキー
export const LOCAL_STORAGE_VISIBLE_KEY = `${LOCAL_STORAGE_KEY_PREFIX}_visible`
// localStorageに軌跡マップ表示状態を保存するキー
export const LOCAL_STORAGE_ANALYZE_TRACK_SETTING_KEY = `${LOCAL_STORAGE_KEY_PREFIX}_analyze_track_setting`
// localStorageにユーザーリスト表示状態を保存するキー
export const LOCAL_STORAGE_USER_LIST_SETTING_KEY = `${LOCAL_STORAGE_KEY_PREFIX}_user_list_setting`

/**
 * 環境変数
 */
// 環境変数内の企業コードプレースホルダー
export const ENV_COMPANY_CODE_PLACEHOLDER = '{companyCode}'

/**
 * 分析タブ測位マップ関連
 */
// 測位地点半径
export const TRACK_POINT_RADIUS = {
  LARGE: 8,
  MEDIUM: 6,
  SMALL: 4,
}
// 測位地点の太さ
export const TRACK_POINT_LINE_WIDTH = {
  LARGE: 5,
  MEDIUM: 4,
  SMALL: 3,
}
// 測位軌跡の太さ
export const TRACK_LINE_WIDTH = {
  LARGE: 3,
  SMALL: 2,
}
// 非表示ユーザーの不透明度
export const INVISIBLE_USER_OPACITY_RATIO = 0.15
// ホバー時のハイライト表示の拡大率
export const HIGHLIGHT_SCALE_FACTOR = 2

/**
 * ユーザー種別
 */
export const USER_TYPE = {
  APP: 'app',
  TAG: 'tag',
  MIXED: 'mixed',
}

/**
 * アプリユーザーのロールID
 *
 * 管理者(1)と一般ユーザー(2)を指す。
 * タグユーザーは ifield-core-components の TAG_USER_ROLE_ID を使用する
 */
export const APP_USER_ROLE_IDS = [1, 2]

/**
 * クラスターアイコン
 */
// クラスター半径
export const CLUSTER_RADIUS = 40
// クラスターアイコンID
export const CLUSTER_ICON_ID = {
  DEFAULT: 'cluster',
  SELECTED: 'clusterSelected',
  APP_DEFAULT: `${USER_TYPE.APP}Cluster`,
  APP_SELECTED: `${USER_TYPE.APP}ClusterSelected`,
  TAG_DEFAULT: `${USER_TYPE.TAG}Cluster`,
  TAG_SELECTED: `${USER_TYPE.TAG}ClusterSelected`,
  MIXED_DEFAULT: `${USER_TYPE.MIXED}Cluster`,
  MIXED_SELECTED: `${USER_TYPE.MIXED}ClusterSelected`,
}
// クラスターアイコン文字色
export const CLUSTER_ICON_TEXT_COLOR = {
  DEFAULT: [255, 255, 255],
  SELECTED: [217, 217, 217],
}
/**
 * クラスタリング対象マップID
 * 'user' -> ユーザー (TheMember)
 * 'report' -> 報告書 (TheReport)
 * 'status' -> ステイタス (TheStatus)
 * 'checkin' -> チェックイン (TheCheckin)
 */
export const CLUSTERING_MAP_ID = {
  USER: 'user',
  REPORT: 'report',
  STATUS: 'status',
  CHECKIN: 'checkin',
}
// 「アイコンをクラスター表示する」の item_key
export const MAP_CLUSTERING_TARGETS_KEY = 'map_clustering_targets'

/**
 * ラベル（地図の吹き出し）の2段目に先頭の表示項目を出す対象
 * 個人設定の選択肢（select_values）の item_value と対応する
 */
export const LABEL_DISP_ITEM_TARGET = {
  USER: 'user',
  PLACE: 'place',
}
// 「任意表示項目のラベル表示」の item_key
// 2026-08-27 に develop へ入ったマイグレーション V4_26_0_01 で登録された項目
export const LABEL_DISP_ITEM_KEY = 'map_additional_label'

/**
 * ラベルの2段目を止める件数（2026-08-26 合意）
 *
 * 1画面にこの件数以上のラベルが出るときは2段目を出さず、1段目（名称）だけにする。
 * 間引きはしない（こちら側の判断で情報が欠落するため）。
 * 境界で表示が点滅しないよう、戻すときは少ない件数まで下がってからにする
 */
export const LABEL_COUNT_LIMIT = {
  // これ以上で2段目を止める
  stop: 200,
  // ここまで減ったら2段目を戻す
  resume: 160,
}

/**
 * 自動チェックイン
 */
// システムデフォルト値（屋外, メートル）
export const DEFAULT_AUTO_CHECKIN_RANGE_OUTDOOR = 50
// システムデフォルト値（屋内, メートル）
export const DEFAULT_AUTO_CHECKIN_RANGE_INDOOR = 2

/**
 * ページの保持（keep-alive）
 */
// 保持するページのコンポーネント名。地図を持つページだけを対象にする
export const KEEP_ALIVE_VIEW_NAMES = [
  'TheMemberDispatch',
  'TheReport',
  'ThePlace',
  'TheStatus',
  'TheCheckin',
  'TheAnalyze',
]
// 同時に保持するページ数の上限
export const KEEP_ALIVE_MAX = 2
